var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarByRegion = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.5,
  r: 12,
  fill: "url(#paint0_linear_34213_82281)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_34213_82281)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1419 4.05953C10.5388 4.17203 10.1013 4.3189 9.62943 4.56578C8.21381 5.3064 7.27631 6.54703 6.93256 8.12515C6.87006 8.41578 6.86068 8.53765 6.86381 9.17203C6.86381 9.7939 6.87318 9.9314 6.93256 10.2002C7.02943 10.6314 7.16693 11.0189 7.36381 11.422C7.57943 11.8595 11.6076 18.1408 11.7294 18.2314C11.8576 18.3252 12.1388 18.322 12.2732 18.2252C12.3357 18.1814 12.7544 17.5564 13.4888 16.4127C14.1044 15.4564 15.0326 14.0095 15.5513 13.2002C16.0701 12.3908 16.5513 11.6189 16.6201 11.4814C16.7982 11.122 16.9513 10.6939 17.0513 10.2658C17.1326 9.91265 17.1388 9.84703 17.1388 9.17203C17.1419 8.53765 17.1326 8.41578 17.0701 8.12515C16.6201 6.06578 15.0951 4.53453 13.0482 4.09078C12.5951 3.9939 11.5857 3.97828 11.1419 4.05953ZM12.7107 6.94703C13.4419 7.20015 13.9826 7.75015 14.2263 8.4814C14.2888 8.67203 14.2982 8.76578 14.2982 9.1564C14.2982 9.54703 14.2888 9.64078 14.2263 9.8314C13.9794 10.572 13.4169 11.1345 12.6763 11.3814C12.4857 11.4439 12.3919 11.4533 12.0013 11.4533C11.6107 11.4533 11.5169 11.4439 11.3263 11.3814C10.5857 11.1345 10.0232 10.572 9.77631 9.8314C9.71381 9.64078 9.70443 9.54703 9.70443 9.1564C9.70443 8.76578 9.71381 8.67203 9.77631 8.4814C10.0201 7.7439 10.6013 7.15953 11.3107 6.9439C11.6107 6.85015 11.6326 6.84703 12.0794 6.85953C12.4169 6.86578 12.5232 6.8814 12.7107 6.94703Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.82895 14.8906C7.22895 15.0656 6.90707 15.1844 6.51645 15.375C5.81332 15.7156 5.32895 16.1312 5.10707 16.5781C4.9977 16.8 4.9852 16.8469 4.97582 17.1219C4.96645 17.3687 4.97582 17.4562 5.03207 17.6219C5.36957 18.6219 6.8977 19.4094 9.2352 19.7938C10.2258 19.9562 10.6414 19.9844 12.0008 19.9844C13.3602 19.9844 13.7758 19.9562 14.7664 19.7938C16.7914 19.4625 18.2508 18.8094 18.7946 17.9875C18.9758 17.7156 19.0414 17.4719 19.0258 17.1219C19.0164 16.8469 19.0039 16.8 18.8946 16.5781C18.6133 16.0062 17.8758 15.475 16.8602 15.1094C16.5133 14.9844 15.6852 14.7469 15.6571 14.7656C15.6477 14.7719 15.0977 15.625 14.4352 16.6594C13.1539 18.6687 13.0477 18.8125 12.7102 18.9781C12.2321 19.2125 11.7696 19.2125 11.2914 18.9781C10.9852 18.8281 10.8102 18.6156 10.2008 17.6562C8.90395 15.6219 8.33832 14.75 8.31957 14.7531C8.30707 14.7531 8.08832 14.8156 7.82895 14.8906Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_34213_82281",
  x1: 6.5,
  y1: 1.5,
  x2: 16,
  y2: 23.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02EAFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A7CEF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_34213_82281"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(4 4)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarByRegion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_by_region.1e5fe8c9674a6e45283a35d06d3c4340.svg";